import { useTranslation } from 'react-i18next';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import { Picker } from '@platform/ui';
import { fieldControlId } from '../../fields/fieldControlId';
import { isFieldRestricted } from '../../fields/fieldRestricted';
import { FieldRenderer } from '../../fields/FieldRenderer';
import { valueOf } from '../valueOf';
import type { IKeyLineProps } from './IKeyLineProps';
import { keyLineKeys } from './keyLineKeys';
import { keyLineLabelKey } from './keyLineLabelKey';
import { useStatusOptions } from './useStatusOptions';

/**
 * Ключовий рядок під назвою (UIUX forms/key-line, прототип v4): компактні поля 30px з міткою всередині — «ВИКОНАВЕЦЬ: · СТАТУС: • ·
 * ПРІОРИТЕТ: • · ТЕРМІН:» (контроли полів у розмірі key; прострочений термін — червоний лише тут). Мітки стандартних полів — підписи
 * платформи, як у прототипі (термін CRM — «ТЕРМІН:», а не підпис поля «Наступний контакт»), решти — підпис поля. У режимі перегляду —
 * сірі й без шевронів, як уся форма; правка йде в чернетку. Статус пропонує лише дозволені переходи від збереженого статусу (новий
 * запис — будь-який). Поле з персональними даними, приховане сервером, — пігулка з міткою й «Приховано». Контроли мають власні id
 * (`kl-<тип>-<поле>`, fieldControlId): ті самі поля в групах форми не дублюють їх.
 */
export function KeyLine({ ws, rt, record, editor, readOnly }: IKeyLineProps) {
  const { t } = useTranslation();
  const strings = useModuleStrings();
  const statusOptions = useStatusOptions(rt);
  return (
    <div className="rec-keyline" data-ro={readOnly ? '1' : '0'}>
      {keyLineKeys(rt).map((key) => {
        const field = rt.fields.find((f) => f.key === key)!;
        const own = keyLineLabelKey(key);
        const label = own ? t(own) : strings.field(rt.key, key, field.label);
        if (key === 'status') {
          return <Picker key={key} id={fieldControlId('kl', rt.key, 'status')} size="key" prefix={`${label}:`} label={label} readOnly={readOnly}
            value={String(valueOf(record, editor.draft, 'status') ?? '')} options={statusOptions(record.id ? record.status : null)} onChange={(v) => editor.setField('status', v || null)} />;
        }
        return <FieldRenderer key={key} bare size="key" prefix={`${label}:`} field={field} rt={rt} ws={ws} record={record} idPrefix="kl"
          value={valueOf(record, editor.draft, key)} onChange={editor.setField} readOnly={readOnly} restricted={isFieldRestricted(record, field)} />;
      })}
    </div>
  );
}
